import React from 'react';
import type { PubSubServiceV1, PubSubTopicV1 } from '@smart/pub-sub-service';
import type { ButtonProps } from '../button';
import { Button } from '../button';

export type PopupButtonProps = {
  publishFunc: PubSubServiceV1['publish'];
  topic: PubSubTopicV1;
  text: string;
  props?: Partial<ButtonProps>;
  callback?: () => void;
};
export const PopupButton: React.FC<PopupButtonProps> = ({ publishFunc, topic, text, callback, props }) => (
  <Button
    variant="primary"
    onClick={() => {
      publishFunc(topic);
      callback && callback();
    }}
    {...props}
  >
    {text}
  </Button>
);
